import { useMemo } from "react";
import useGetAdvisors from "../../Entity/hooks/useGetAdvisors";
import useGetTaskV3_1 from "../../Tasks/hooks/useGetTask.v3_1";
import { AdvisorId } from "../../Types";
import { createErrorState, createLoadingState, createSuccessState, getFirstQueryError, hasAnyQueryError, isAnyQueryLoading, } from "../utils/hookStateHelpers";
import useGetTransitionDetails from "./useGetTransitionDetails";
export const useGetTransitionDetailsDto = (transitionId, authConfig) => {
    const transitionDetailsQuery = useGetTransitionDetails(transitionId, authConfig);
    const taskQuery = useGetTaskV3_1(transitionDetailsQuery.data?.taskId ?? null, authConfig, false, {
        enabled: !!transitionDetailsQuery.data?.taskId &&
            !transitionDetailsQuery.isLoading,
    });
    const advisorIds = useMemo(() => {
        if (!taskQuery.data?.advisors) {
            return [];
        }
        return taskQuery.data.advisors.map((advisor) => AdvisorId.parse(advisor.id));
    }, [taskQuery.data?.advisors]);
    const advisorsQuery = useGetAdvisors(advisorIds, authConfig);
    const allQueries = [transitionDetailsQuery, taskQuery, advisorsQuery];
    if (isAnyQueryLoading(allQueries)) {
        return createLoadingState();
    }
    if (hasAnyQueryError(allQueries)) {
        return createErrorState(getFirstQueryError(allQueries));
    }
    if (!transitionDetailsQuery.data || !taskQuery.data) {
        return createErrorState(new Error("Missing required transition or task data"));
    }
    const transitionDetailsDto = {
        ...transitionDetailsQuery.data,
        task: taskQuery.data,
        advisors: advisorsQuery.data ?? [],
    };
    return createSuccessState(transitionDetailsDto);
};
//# sourceMappingURL=useGetTransitionDetailsDto.js.map